import { Modal, Select } from 'antd';
import { useMemo, useState } from 'react';

import type { SalesFunnelFilterDto } from '@app/api/SalesFunnels';

import type { FC } from 'react';

import './LeadsRegistryFunnelStageModal.scss';

interface LeadsRegistryFunnelStageModalProps {
  open: boolean;
  funnels: SalesFunnelFilterDto[];
  isLoading: boolean;
  onCancel(): void;
  onConfirm(funnelStageId: number): void;
}

export const LeadsRegistryFunnelStageModal: FC<
  LeadsRegistryFunnelStageModalProps
> = ({ open, funnels, isLoading, onCancel, onConfirm }) => {
  const [funnelId, setFunnelId] = useState<number | null>(null);
  const [stageId, setStageId] = useState<number | null>(null);

  const funnelOptions = useMemo(
    () => funnels.map(({ Id, Name }) => ({ value: Id, label: Name ?? '' })),
    [funnels]
  );

  const stageOptions = useMemo(() => {
    const stages = funnels.find(({ Id }) => Id === funnelId)?.Stages ?? [];

    return stages.map(({ Id, Name }) => ({ value: Id, label: Name ?? '' }));
  }, [funnels, funnelId]);

  const resetState = () => {
    setFunnelId(null);
    setStageId(null);
  };

  const funnelChangeHandler = (nextFunnelId: number) => {
    setFunnelId(nextFunnelId);
    setStageId(null);
  };

  const cancelHandler = () => {
    resetState();
    onCancel();
  };

  const confirmHandler = () => {
    if (stageId === null) return;

    onConfirm(stageId);
    resetState();
  };

  return (
    <Modal
      className="LeadsRegistryFunnelStageModal"
      title="Изменить этап воронки"
      open={open}
      okText="Сохранить"
      cancelText="Отменить"
      onOk={confirmHandler}
      onCancel={cancelHandler}
      okButtonProps={{ loading: isLoading, disabled: stageId === null }}
      cancelButtonProps={{ disabled: isLoading }}
    >
      <Select<number>
        className="LeadsRegistryFunnelStageModal__select"
        showSearch
        placeholder="Выберите воронку"
        optionFilterProp="label"
        options={funnelOptions}
        value={funnelId ?? undefined}
        onChange={funnelChangeHandler}
      />

      <Select<number>
        className="LeadsRegistryFunnelStageModal__select"
        showSearch
        placeholder="Выберите этап"
        optionFilterProp="label"
        disabled={funnelId === null}
        options={stageOptions}
        value={stageId ?? undefined}
        onChange={setStageId}
      />
    </Modal>
  );
};
